import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mx-auto mt-12 max-w-[1436px] lg:mt-25 lg:pl-4',
    cards:
      '[--slide-size:322px] [--slide-spacing:12px] lg:[--slide-size:353px]',
    card: 'block',
    cardImage: 'h-auto w-full',
    linkContainer: 'mt-5 flex items-center gap-8 px-6 py-5 lg:px-10',
    linkWrapper: '',
    linkTitle:
      'text-brand-bioderma mb-3 text-[16px] leading-[1.6] font-medium lg:mb-[10px] lg:text-[19px]',
    link: 'text-brand-bioderma flex items-center gap-2 text-[13px] font-medium tracking-[0.06em] uppercase hover:text-black',
    linkImage: ''
  }
});
